import { render, staticRenderFns } from "./Model3DViewer.vue?vue&type=template&id=1208a64b&scoped=true"
import script from "./Model3DViewer.vue?vue&type=script&lang=js"
export * from "./Model3DViewer.vue?vue&type=script&lang=js"
import style0 from "./Model3DViewer.vue?vue&type=style&index=0&id=1208a64b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208a64b",
  null
  
)

export default component.exports